import { render, staticRenderFns } from "./IntroductionEn.vue?vue&type=template&id=c443f366&scoped=true&"
import script from "./IntroductionEn.vue?vue&type=script&lang=js&"
export * from "./IntroductionEn.vue?vue&type=script&lang=js&"
import style1 from "./IntroductionEn.vue?vue&type=style&index=1&id=c443f366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c443f366",
  null
  
)

export default component.exports